import React from 'react'

const ArrowDown = () => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill="#3F5063" d="M32.6,56.5c-0.6,0-1-0.4-1-1v-46c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1v46C33.6,56.1,33.2,56.5,32.6,56.5z"/>
      <path fill="#6EC18A" d="M32.5,56.8c-0.3,0-0.5-0.1-0.7-0.3L13.4,38.1c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l17.7,17.7l17.7-17.7
	c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L33.2,56.5C33,56.7,32.8,56.8,32.5,56.8z"/>
    </svg>
  )
}

export default ArrowDown
